

































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { Scatter } from 'vue-chartjs';
import LineChart from '@/components/Chart/LineChart.vue';

import FilterBar from '@/components/Filters/FilterBar.vue';
import { IIndicatorValue } from '@/model/datamart';
import { IIndicator, ISensorDevice } from '@/model/meta';

import { ColorScheme } from '@/utils/colorscheme';

export default Vue.extend({
    name: 'Graphs',
    metaInfo: {
        title: 'Графики значений',
    },
    components: {
        FilterBar,
        LineChart,
    },
    computed: {
        ...mapGetters('viewing', {
            preloader: 'getPreloader',
            failLoading: 'getFailLoading',
            activeFormRequest: 'getActiveFormRequest',
            failedFormRequest: 'getFailedFormRequest',
            gridData: 'getIndictorValuesGrids',
            devicesFilter: 'getActiveDevices',
            indicatorsFilter: 'getAbailableIndicators',
        }),
        ...mapGetters('auth', {
            getUserId: 'getUserId',
        }),
        gridDataCast(): { [key: string]: IIndicatorValue[] } {
            const dataArray = this.gridData as {
                [key: string]: IIndicatorValue[];
            };
            if (dataArray !== undefined && dataArray !== null) {
                return dataArray;
            }
            return {} as { [key: string]: IIndicatorValue[] };
        },
        filterSetting(): Array<any> {
            return [
                {
                    code: 'device',
                    filterType: 'search-select',
                    label: 'Устройство:',
                    dataSet: this.devicesFilter,
                    textField: 'name',
                    valueField: 'ALL_OBJECT',
                },
                {
                    code: 'indicators',
                    filterType: 'multi-select',
                    selectSize: 3,
                    label: 'Показатели:',
                    dataSet: this.indicatorsFilter,
                    masterValue: this.getDeviceFilterId(),
                    textField: 'name',
                    valueField: 'ALL_OBJECT',
                },
                {
                    code: 'period',
                    filterType: 'range-datetime',
                    label: 'Период:',
                },
            ];
        },
        graphsData(): any {
            const datasets = [];
            for (const key in this.gridData) {
                const value = this.gridData[key];
                const colorStr = this.colorscheme.getNext();
                if (value !== undefined) {
                    const dataObj = {
                        label: this.graphsTitle(key),
                        yAxisID: key,
                        fill: false,
                        showLine: true,
                        spanGaps: true,
                        borderColor: colorStr,
                        backgroundColor: colorStr,
                        data: this.graphsDataRow(value),
                    };
                    datasets.push(dataObj);
                }
            }
            return { datasets: datasets };
        },
        graphShow(): boolean {
            return Object.keys(this.gridDataCast).length > 0;
        },
        showEmptyData(): boolean {
            return !this.graphShow && !this.firstShow;
        },
        graphsOptions(): any {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            type: 'time',
                            time: {
                                displayFormats: {
                                    year: 'YYYY',
                                    quarter: 'MM.YYYY',
                                    month: 'MM.YYYY',
                                    week: 'DD.MM.YY',
                                    day: 'DD.MM.YY',
                                    hour: 'DD.MM.YY HH:mm',
                                    minute: 'DD.MM.YY HH:mm',
                                    second: 'DD.MM.YY HH:mm:ss',
                                }
                            },
                            ticks: {
                                maxTicksLimit: 9,
                            }
                        }
                    ],
                    yAxes: this.getYAxes(),
                }
            };
        },
    },
    methods: {
        ...mapActions('viewing', {
            resetForm: 'resetForm',
            loadDevices: 'loadActiveDevices',
            setIndicators: 'setAvailableIndicators',
            cleanIndicators: 'cleanAvailableIndicators',
            loadData: 'loadValuesGrids',
            resetGraphsData: 'resetGridsData',
        }),
        inputHandler() {
            if (this.filters['device'] !== undefined) {
                this.setIndicators(this.filters['device']);
            }
            this.filterCompleted = this.getFilterCompleted();
        },
        refreshAction() {
            if (this.filterCompleted) {
                this.loadData({
                    device: this.filters['device'],
                    indicators: this.filters['indicators'],
                    begin: this.filters['period'][0],
                    end: this.filters['period'][1],
                }).then(() => {
                    this.firstShow = false;
                    this.updateChart();
                });
            }
        },
        getDeviceFilterId(): string {
            if (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null
            ) {
                return this.filters['device']['sensorDeviceId'];
            }
            return '';
        },
        updateChart(): void {
            this.colorscheme.resetPosition();
            this.nextAxesLeft = true;
            (this.$refs.chart as Scatter).renderChart(
                this.graphsData,
                this.graphsOptions
            );
        },
        graphsTitle(indicatorId: string): string {
            if (this.filters['device'] !== undefined &&
                this.filters['device'] !== null &&
                this.filters['indicators'] !== undefined &&
                this.filters['indicators'] !== null) {
                const indicators = this.filters['indicators'] as IIndicator[];
                if (!indicators) return '';
                const indicator = indicators.find(item => {
                    return item.indicatorId === indicatorId;
                });
                if (!indicator) return '';

                return (
                    (this.filters['device'] as ISensorDevice).name +
                    '(' +
                    indicator.name +
                    ')'
                );
            }
            return '';
        },
        graphsDataRow(
            valueSet: IIndicatorValue[]
        ): Array<{ x: Date; y: number | undefined }> {
            let resultData = [] as Array<{ x: Date; y: number | undefined }>;
            if (valueSet.length > 0) {
                resultData = valueSet
                    .map(item => {
                        return { x: item.timestamp, y: item.value };
                    })
                    .sort(function(a, b) {
                        if (a.x < b.x) return -1;
                        if (a.x > b.x) return 1;
                        return 0;
                    });
            }
            return resultData;
        },
        getYAxes() {
            const resultAxes = [];
            for (const key in this.gridData) {
                const value = this.gridData[key];
                if (value !== undefined) {
                    const dataObj = {
                        id: key,
                        type: 'linear',
                        position: this.getAxesNextPosition(),
                        scaleLabel: {
                            display: true,
                            labelString: this.getAxesLabel(key),
                        },
                    };
                    resultAxes.push(dataObj);
                }
            }
            return resultAxes;
        },
        getAxesNextPosition(): 'right' | 'left' {
            const next = this.nextAxesLeft ? 'left' : 'right';
            this.nextAxesLeft = !this.nextAxesLeft;
            return next;
        },
        getAxesLabel(key: string): string {
            const indicators = this.filters['indicators'] as IIndicator[];
            if (indicators !== undefined) {
                const indicator = indicators.find(item => {
                    return item.indicatorId === key;
                });

                if (indicator !== undefined) return indicator.name;
            }

            return '';
        },
        getFilterCompleted(): boolean {
            return (
                this.filters['device'] !== undefined &&
                this.filters['device'] !== null &&
                this.filters['indicators'] !== undefined &&
                this.filters['indicators'] !== null &&
                this.filters['indicators'].length > 0 &&
                this.filters['period'] !== undefined &&
                this.filters['period'] !== null &&
                this.filters['period'].length > 1
            );
        }
    },
    mounted() {
        this.loadDevices(this.getUserId);
        this.resetGraphsData();
    },
    data() {
        return {
            filters: {} as any,
            firstShow: true as boolean,
            nextAxesLeft: true as boolean,
            colorscheme: new ColorScheme(),
            filterCompleted: false as boolean,
        };
    }
});
